module.exports={render:function (){
var _obj, _obj$1, _obj$2, _obj$3;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "after-enter": _vm.afterEnter,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-dialog__wrapper",
    on: {
      "mousedown": _vm.handleWrapperMousedown,
      "mouseup": _vm.handleWrapperMouseup,
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleWrapperClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    key: _vm.key,
    ref: "dialog",
    class: [
      'el-dialog',
      ( _obj = {
        'is-fullscreen': _vm.fullscreen,
        'el-dialog--center': _vm.center
      }, _obj[("bg-" + (_vm.$attrs['bg-color']))] = _vm.$attrs['bg-color'], _obj ),
      _vm.customClass
    ],
    style: (_vm.style),
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.title || 'dialog'
    }
  }, [_c('div', {
    class: [
      'el-dialog__header',
      ( _obj$1 = {}, _obj$1[("bg-" + (_vm.$attrs['header-bg-color']))] = _vm.$attrs['header-bg-color'], _obj$1 )
    ]
  }, [_vm._t("title", function() {
    return [_c('span', {
      staticClass: "el-dialog__title"
    }, [_vm._v(_vm._s(_vm.title))])]
  }), _vm._v(" "), (_vm.showClose) ? _c('button', {
    staticClass: "el-dialog__headerbtn",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "el-dialog__close el-icon el-icon-close"
  })]) : _vm._e()], 2), _vm._v(" "), (_vm.rendered) ? _c('div', {
    class: [
      'el-dialog__body',
      ( _obj$2 = {}, _obj$2[("bg-" + (_vm.$attrs['body-bg-color']))] = _vm.$attrs['body-bg-color'], _obj$2 )
    ]
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    class: [
      'el-dialog__footer',
      ( _obj$3 = {}, _obj$3[("bg-" + (_vm.$attrs['footer-bg-color']))] = _vm.$attrs['footer-bg-color'], _obj$3 )
    ]
  }, [_vm._t("footer")], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06d8b01e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/dialog/src/component.vue
// module id = 2067
// module chunks = 137